
import { useStore } from "vuex";
import { computed, defineComponent } from "vue";
export default defineComponent({
  name: "CharacterTable",
  components: {},
  setup() {
    const store = useStore();
    const stats = computed(() => {
      return {
        ActionPoints: store.state.build.CharStats.ActionPoints.value,
        MeleeDamage: store.state.build.CharStats.MeleeDamage.value,
        CriticalChance: store.state.build.CharStats.CriticalChance.value,
        CarryWeight: Math.round(store.state.build.CharStats.CarryWeight.value),
        Sequence: store.state.build.CharStats.Sequence.value,
        HealingRate: store.state.build.CharStats.HealingRate.value,
        PartyPoints: store.state.build.CharStats.PartyPoints.value,
        MaximumPerks: store.state.build.CharStats.MaximumPerks.value,
        SkillPointsPerLevel:
          store.state.build.CharStats.SkillPointsPerLevel.value,
        HitPointsPerLevel: store.state.build.CharStats.HitPointsPerLevel.value,
        SightRange: store.state.build.CharStats.SightRange.value,
        WeaponRange: "-",
      };
    });

    return {
      state: store.state,
      stats,
    };
  },
});
